import { Translate } from '@dreryk/react-common';
import { ValidationErrorNotification } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../translations';

export const DosageExceedingPackagesMessage = (): JSX.Element => {
   return (
      <ValidationErrorNotification
         testId={'dosageExceedingPackages'}
         label={<Translate>{prescriptionTranslationKeys.numericalDosage.dosageExceedingPackages}</Translate>}
      />
   );
};
